<template>
  <component
    :is="
      isModal
        ? 'ModalComponent'
        : isBotomSheet
          ? 'BottomSheetComponent'
          : windowWidth > 800
            ? 'ModalComponent'
            : 'BottomSheetComponent'
    "
    ref="component"
    headerBg="#fff"
    :onOpening="onOpening"
    :onClosing="onClosing"
    :onOpened="onOpened"
    :onClosed="onClosed"
    :onOverlayClick="onOverlayClick"
    :onCancelClick="onCancelClick"
    :onBackButtonClick="onBackButtonClick"
    :iconLeftBg="iconLeftBg"
    :overlayerCanDismiss="overlayerCanDismiss"
  >
    <template #header><div></div></template>

    <div class="w-full h-full ">
      <slot name="header">
        <slot name="titleContainer">
          <span class="px-4 text-2xl md:text-2xl block font-medium">
            <slot name="titleText"></slot>
          </span>
        </slot>
        <div class="py-2"></div>
        <slot name="subtitleContainer">
          <span class="textComponent px-4 text-sm md:text-base block title-color">
            <slot name="subtitleText"></slot>
          </span>
        </slot>
        <slot name="banner"></slot>
        <div class="py-4"></div>
      </slot>

      <!-- Body -->
      <slot />

      <!-- Footer -->
      <div
        class="px-4 py-3 flex sm:px-6 gap-3 w-full"
        v-if="!!$slots.primaryButton || !!$slots.cancelButton"
        :class="{ 'flex-row-reverse': buttonsToRight }"
      >
        <button
          class="p-4 ripple"
          v-if="!!$slots.primaryButton"
          @click="onPrimaryClick"
          :loading="primaryButtonLoading"
        >
          <span class="title-color">
            <slot name="primaryButton"></slot>
          </span>
        </button>
        <button
          class="p-4 ripple"
          v-if="!!$slots.cancelButton"
          @click="onCancelClick ? onCancelClick() : hide()"
        >
          <span class="title-color">
            <slot name="cancelButton"></slot>
          </span>
        </button>
      </div>
    </div>
  </component>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue'
import BottomSheetComponent from './BottomSheet.vue'
import ModalComponent from './ModalComponent.vue'

export default defineComponent({
  name: 'BottomSheetModal',
  components: { BottomSheetComponent, ModalComponent },
  props: {
    isModal: Boolean,
    isBotomSheet: Boolean,

    // événements
    onOpening: { type: Function, default: () => {} },
    onClosing: { type: Function, default: () => {} },
    onOpened: { type: Function, default: () => {} },
    onClosed: { type: Function, default: () => {} },
    onPrimaryClick: { type: Function, default: () => {} },
    onOverlayClick: { type: Function, default: null },
    onCancelClick: { type: Function, default: null },
    onBackButtonClick: { type: Function, default: null },

    // apparence / options
    iconLeftBg: { type: String, default: 'red' },
    overlayerCanDismiss: { type: Boolean, default: true },
    buttonsToRight: { type: Boolean, default: true },
    primaryButtonLoading: { type: Boolean, default: false },
  },
  setup() {
    const windowWidth = ref(window.innerWidth)

    const updateWidth = () => {
      windowWidth.value = window.innerWidth
    }

    onMounted(() => {
      window.addEventListener('resize', updateWidth)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateWidth)
    })

    return { windowWidth }
  },
  methods: {
    show() {
      this.$refs.component.show()
    },
    hide() {
      this.$refs.component.hide()
    },
    isVisible() {
      return this.$refs.component.isVisible()
    },
  },
})
</script>
